import { LocationFeatureFlags } from '@frontend/wam-views';
import { theme } from '@frontend/theme';
import { Button, Text, useModalControl } from '@frontend/design-system';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function FeatureFlags() {
  const modalControl = useModalControl();

  return (
    <Page
      title='Feature Modifications'
      subtitle={
        <>
          <Text css={{ marginBottom: theme.spacing(1) }} color='light'>
            Make changes to a customer’s location account.
          </Text>
          <Button css={{ paddingLeft: 0 }} iconName='info' variant='tertiary'>
            Learn more about the differences between feature flags and customizations
          </Button>
        </>
      }
      breadcrumbs={[
        {
          label: 'Feature Flags',
        },
      ]}
      action={
        <Button onClick={modalControl.openModal} iconName='plus'>
          Add New Feature Flag
        </Button>
      }
    >
      <LocationFeatureFlags />
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/feature-flags/',
  component: FeatureFlags,
  type: 'auth',
  locationRequired: true,
});
